import React from "react";

const LoadingButton = ({ height = "18px", width = "18px", className }) => {
  return (
    <div
      class="spinner-border"
      style={{ height: { height }, width: { width } }}
      role="status"
      className={className}
    ></div>
  );
};

export default LoadingButton;
